import React from "react";
import CommonDropDown from "../Common/DropDown/CommonDropDown";

type DisplayValue<T extends number | string> = {
  value: T;
  display: string;
};

type Props<T extends number | string> = {
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  value: T;
  label: string;
  onChange: (value: T) => void;
  displayValues: DisplayValue<T>[];
  disabled?: boolean;
};

export default function CommandPanelComboBox<T extends number | string>({
  style = {},
  labelStyle = {},
  value,
  label,
  displayValues,
  onChange,
  disabled,
}: Props<T>) {
  const dropDownDisplayValue = displayValues.map((dv) => {return {...dv, disabled: false}})
  return (
    <div
      style={{
        display: "flex",
        fontSize: "20px",
        lineHeight: "40px",
        color: "#FFFFFF",
        backgroundColor: "#414042",
        padding: "10px",
        textAlign: "left",
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none",
        userSelect: "none",
        ...style,
      }}
    >
      <div style={{ width: 150, ...labelStyle }}>{label}</div>
      <CommonDropDown
        id={`${label}_drop_down`}
        dropDownDisplayValues={dropDownDisplayValue}
        onChange={onChange}
        value={value}
        disabled={disabled}
        style={{
          flexGrow: 1,
          width: '100%',
        }}
      />
    </div>
  );
}
